import { initChat } from '../chat'
import { fetchUrl } from '../utils'

const cookieModal = document.querySelector('[data-cookie-modal]')
const cookieModalAdditional = document.querySelector('[data-cookie-modal-additional]')
const cookieOverlay = document.querySelector('[data-cookie-overlay]')

/* Creating object with initial settings for cookies */
const consentParams = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
  functionality_storage: 'denied',
}

const consentParamsGroups = {
  necessary: 'granted',
  functional: 'granted',
  marketing: 'granted',
}

if (!localStorage.getItem('widgets-allowed') || !localStorage.getItem('selected-cookie')) {
  if (
    !window.location.href.includes('cookies-policy') &&
    !window.location.href.includes('privacy-policy')
  ) {
    openModal()
  }
} else {
  initChat()
}

/* ----------------------- Toggle description info --------------------- */
const cookieItems = document.querySelectorAll('[data-cookie-item]')

cookieItems.forEach(el => {
  /* Create a handler for each cookie Btn */
  const cookieElTitle = el.querySelector('[data-show-more-cookie-title]')

  cookieElTitle.addEventListener('click', toggleItem(el))
})

function toggleItem(currListItem) {
  return function () {
    const cookieElTitle = currListItem.querySelector('[data-show-more-cookie-title]')
    const cookieInfoEl = currListItem.querySelector('[data-cookie-info]')

    if (currListItem.classList.contains('opened')) {
      currListItem.classList.remove('opened')
      cookieElTitle.classList.remove('opened')
      cookieInfoEl.style.height = '0'
    } else {
      const openedFaqItems = document.querySelectorAll('.opened[data-show-more-cookie-item]')
      openedFaqItems.forEach(el => {
        el.classList.remove('opened')
        cookieElTitle.classList.remove('opened')
        const answear = el.querySelector('[data-cookie-info]')
        answear.style.height = '0'
      })

      currListItem.classList.add('opened')
      cookieElTitle.classList.add('opened')

      cookieInfoEl.style.height = cookieInfoEl.scrollHeight + 'px'
    }
  }
}

/* ------------------------ Toggle cookie handling ------------------------ */

/* Visual click at Toggle btn */
const cookieToggleElement = document.querySelectorAll('[data-cookie-toggle-item]')

cookieToggleElement.forEach(el => {
  el.addEventListener('click', () => {
    el.classList.toggle('active')
  })
})

/* setting marketing cookies */
const marketingToggleBtn = document.querySelector('[data-cookie-marketing]')

marketingToggleBtn.addEventListener('click', () => {
  const isActive = marketingToggleBtn.classList.contains('active')
  const state = isActive ? 'granted' : 'denied'

  const marketingCookieObj = {
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
  }

  Object.assign(consentParams, marketingCookieObj)
  consentParamsGroups.marketing = isActive ? 'granted' : 'denied'
})

/* Setting functional cookies */
const functionalToggleBtn = document.querySelector('[data-cookie-functional]')

functionalToggleBtn.addEventListener('click', () => {
  const isActive = functionalToggleBtn.classList.contains('active')

  const functionalCookieObj = {
    functionality_storage: isActive ? 'granted' : 'denied',
  }

  Object.assign(consentParams, functionalCookieObj)
  consentParamsGroups.functional = isActive ? 'granted' : 'denied'
})

/* Setting necessary cookies */
const necessaryToggleBtn = document.querySelector('[data-cookie-necessary]')

necessaryToggleBtn.addEventListener('click', () => {
  const isActive = necessaryToggleBtn.classList.contains('active')

  const necessaryCookieObj = {
    analytics_storage: isActive ? 'granted' : 'denied',
  }

  Object.assign(consentParams, necessaryCookieObj)
  consentParamsGroups.necessary = isActive ? 'granted' : 'denied'
})

/* Accept All cookies button*/
const acceptAllCookiesBtn = document.querySelector('[data-cookie-accept-all-btn]')

acceptAllCookiesBtn.addEventListener('click', () => {
  const allowAllParams = {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    analytics_storage: 'granted',
    functionality_storage: 'granted',
  }

  localStorage.setItem('selected-cookie', JSON.stringify(allowAllParams))
  localStorage.setItem('widgets-allowed', true)

  window.initializeGTM()

  sendConsentData()

  closeModal()
  initChat()
})

/* Set selected cookie button */
const selectedCookiesSaveBtn = document.querySelector('[data-cookie-save-btn]')

selectedCookiesSaveBtn.addEventListener('click', () => {
  localStorage.setItem('selected-cookie', JSON.stringify(consentParams))
  localStorage.setItem('widgets-allowed', true)

  window.initializeGTM()

  sendConsentData()

  closeModal()
  initChat()
})

/* "Advanced settings" button */
const cookieBtnAdditional = document.querySelector('[data-cookie-btn-additional]')

/* Button "less settings" */
const cookieBtnLess = cookieModalAdditional.querySelector('[data-cookie-btn-less]')

function sendConsentData() {
  fetchUrl(`${process.env.BASE_URL}/v1/analytic/cookies/`, {
    method: 'POST',
    body: JSON.stringify(consentParamsGroups),
    headers: { 'Content-Type': 'application/json' },
  })
}

/* Function for displaying the modal */
function showModal(modal) {
  modal.style.display = 'block'

  /* setting checkboxes to unchecked state (in case if smth was selected and user opened some ther page) */
  const modalInputs = modal.querySelectorAll('input[type="checkbox"]')

  for (const input of modalInputs) {
    input.checked = true
    input.classList.add('active')
  }

  const initialSelectedFields = {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    analytics_storage: 'granted',
    functionality_storage: 'granted',
  }

  Object.assign(consentParams, initialSelectedFields)
}

/* Function for hiding a modal */
function hideModal(modal) {
  modal.style.display = 'none'
}

/* The event of clicking on the "advanced settings" button */
cookieBtnAdditional.addEventListener('click', () => {
  hideModal(cookieModal)

  showModal(cookieModalAdditional)
})

/* The event of clicking on the "less settings" button */
cookieBtnLess.addEventListener('click', () => {
  hideModal(cookieModalAdditional)

  showModal(cookieModal)
})

function closeModal() {
  cookieModal.style.display = 'none'
  cookieModalAdditional.style.display = 'none'
  cookieOverlay.classList.remove('opened')
}

function openModal() {
  cookieModal.style.display = 'block'
  cookieOverlay.classList.add('opened')
}
